import type { ComponentProps } from 'react'
import React from 'react'

import { AnalyticsCard } from '../../../../analyticsModule/components/AnalyticsCard/AnalyticsCard'
import { analyticsDecoratorLabelsMap } from '../../../../consts'
import type { AnalyticsDecorator } from '../../../../types'
import * as S from './AnalyticsCardWrapper.styled'

type AnalyticsCardWrapperProps = ComponentProps<typeof AnalyticsCard> & {
  enabled: boolean
  decorator?: AnalyticsDecorator
}

export const AnalyticsCardWrapper = ({
  enabled,
  decorator,
  ...rest
}: AnalyticsCardWrapperProps) => {
  if (!enabled) return null

  if (decorator) {
    return (
      <S.Decorator>
        <S.Label>{analyticsDecoratorLabelsMap[decorator]}</S.Label>
        <AnalyticsCard {...rest} />
      </S.Decorator>
    )
  }

  return <AnalyticsCard {...rest} />
}
